<script setup lang="ts">
useMediaProtection()
</script>
<template>
  <UApp :toaster="{ position: 'top-right' }">
    <NuxtPwaManifest />
    <NuxtLoadingIndicator color="#dfbb80" class="z-[10000000] absolute" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
